/**
* @prop --uic-list-item-height-default: The height of an item with a single line of content 
* @prop --uic-list-item-height-multiline: The height of an item with two lines of content ("multiline") 
* @prop --uic-list-item-padding: The padding of the interactable area of a list item.
*/

uic-list-item {
    box-sizing: border-box;
    position: relative;
    display: block;
    outline: none;
    cursor: pointer;
    padding: 4px 0;
    height: var(--uic-list-item-height-default);
    font-size: var(--uic-font-size-medium);
    line-height: var(--uic-line-height-medium);

    &:hover .uic-list-item__wrapper {
        color: var(--uic-color-blue3);
        border-color: var(--uic-color-blue2);
    }

    &:active .uic-list-item__wrapper {
        border-color: var(--uic-color-blue2);
        background: var(--uic-color-blue2a10);
        color: var(--uic-color-blue3);
    }

    &:focus .uic-list-item__wrapper {
        border-color: var(--uic-color-blue2);
        border-width: 2px;
    }

    &[selected] .uic-list-item__wrapper {
        font-weight: 600;
        background: var(--uic-color-blue0a40);
        border-color: var(--uic-color-blue2);
        box-shadow: 0 2px 8px 0 var(--uic-color-blue2a25);
        color: var(--uic-color-blue4);

        &::before {
            @include absolute();
            content: "";
            z-index: 1;
            box-shadow: 0 2px 8px 0 var(--uic-color-blue2a25);
        }
    }

    &[disabled] {
        color: var(--uic-color-grey3a75);
        cursor: auto;
        pointer-events: none;
    }

    &[multiline] {
        height: var(--uic-list-item-height-multiline);
    }

    slot-fb {
        display: contents;
    }

    .uic-list-item {
        &__wrapper {
            display: flex;
            align-items: center;
            position: relative;
            box-sizing: border-box;
            height: 100%;
            padding: var(--uic-list-item-padding);
            border-top: 1px solid transparent;
            border-bottom: 1px solid transparent;
        }

        &__icon {
            margin-right: 8px;
        }

        &__content {
            flex: 1;
            min-width: 0;
        }

        &__content-default {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &__content-primary {
            font-weight: var(--uic-font-weight-semibold);
        }
    }
}

// keep scroll init as scoped as possible
[uic-scroll-init] > uic-list-item .uic-list-item__content-default {
    // add temporary padding on the left to account for ignored padding on the right
    padding-left: 8px;
    overflow: visible;
}
